/** Auto-generated by scripts/generate-destination-catalog.js — do not edit by hand. */
export const DESTINATION_CATALOG = [
  {
    "name": "Everest Base Camp",
    "slug": "everest-base-camp",
    "category": "viewpoint",
    "summary": "The classic trek to the foot of the world's highest mountain, 5,364m above sea level.",
    "body": "Everest Base Camp (EBC) is the endpoint of Nepal's most iconic trek, reached via Lukla, Namche Bazaar, and Tengboche monastery over 8-12 days. Most trekkers combine it with a side trip to Kala Patthar for the classic Everest sunrise view.",
    "why_visit": "Standing at the foot of the world's highest mountain, surrounded by Sherpa culture and some of the most dramatic scenery on Earth, is a once-in-a-lifetime experience for most who do it.",
    "history": "The trail was pioneered by early Everest expeditions in the 1950s, including the 1953 Hillary-Norgay ascent. It became a mainstream trekking route from the 1960s onward as Lukla's airstrip opened the region to non-mountaineers.",
    "culture": "The route passes through Sherpa villages where Tibetan Buddhism shapes daily life — prayer flags, mani walls, and monasteries like Tengboche punctuate the trail.",
    "local_food": "Teahouse staples: dal bhat, Sherpa stew, momos, and garlic soup (believed locally to help with altitude).",
    "emergency_info": "Altitude sickness is the primary risk above 3,000m. Acclimatization days are built into standard itineraries; know the symptoms of AMS and descend if they worsen. Helicopter evacuation is available but expensive without insurance.",
    "locals_know": "Guides and porters are usually tipped directly and separately at the end of the trip, on top of whatever you paid the trekking company — this is the norm, not an optional extra, and it's worth budgeting for from the start rather than deciding on the last day.",
    "tourist_mistakes": "Flying into Lukla and starting the trek the same day is a common mistake — Lukla flights are weather-dependent and delays are routine, so a same-day start leaves zero buffer before your itinerary is already behind schedule.",
    "best_season": "March-May, September-November",
    "worst_season": "June-August (monsoon: cloud, leeches, flight delays)",
    "difficulty": "strenuous",
    "budget_level": "mid_range",
    "time_required": "12-14 days round trip from Kathmandu",
    "latitude": 28.0026,
    "longitude": 86.8528,
    "altitude_m": 5364,
    "district": {
      "name": "Solukhumbu",
      "slug": "solukhumbu"
    },
    "published": true
  },
  {
    "name": "Sagarmatha National Park",
    "slug": "sagarmatha-national-park",
    "category": "national_park",
    "summary": "UNESCO World Heritage-listed national park protecting the Everest region's peaks, forests, and Sherpa villages.",
    "body": "Sagarmatha National Park covers 1,148 sq km of the Khumbu region, including Mount Everest itself. Home to Sherpa communities, monasteries, and wildlife including the snow leopard and red panda.",
    "why_visit": "It's the gateway to (and protector of) the entire Everest region — its entry permit funds conservation across the whole trekking area.",
    "history": "Established in 1976 and inscribed as a UNESCO World Heritage Site in 1979 for its exceptional natural beauty and as habitat for rare species.",
    "culture": "Encompasses Sherpa settlements including Namche Bazaar, the unofficial capital of the Khumbu.",
    "local_food": null,
    "emergency_info": "Same altitude-sickness precautions as the rest of the Khumbu apply throughout the park.",
    "locals_know": "The entry permit fee funds conservation and community projects across the whole Khumbu region — it's usually bundled into a trekking package without being itemized, so ask your operator to show the actual permit receipt if you want to see where that part of your money goes.",
    "tourist_mistakes": "Arranging the park permit informally through a guesthouse or unlicensed middleman instead of a registered trekking agency or the official checkpoint can cause real problems at exit checks — get it through a proper channel, not a shortcut.",
    "best_season": "March-May, September-November",
    "worst_season": "June-August (monsoon)",
    "difficulty": "hard",
    "budget_level": "mid_range",
    "time_required": "Entry point for multi-day treks",
    "latitude": 27.9881,
    "longitude": 86.7247,
    "altitude_m": 2845,
    "district": {
      "name": "Solukhumbu",
      "slug": "solukhumbu"
    },
    "published": true
  },
  {
    "name": "Phewa Lake",
    "slug": "phewa-lake",
    "category": "lake",
    "summary": "Pokhara's centerpiece lake, with reflections of the Annapurna range on a clear day.",
    "body": "Phewa Lake is the second-largest lake in Nepal and the heart of Pokhara's tourist district, Lakeside. Boating, the Tal Barahi temple on its island, and views of Machapuchare (Fishtail) make it a standard stop for every Pokhara itinerary.",
    "why_visit": "The easiest, most accessible way to see Himalayan peaks reflected in water, right in a walkable city with cafes, shops and coworking spaces around it.",
    "history": "A natural lake that has been central to Pokhara's identity since the city developed as a tourism hub from the 1960s onward, when the first trekkers began passing through en route to Annapurna.",
    "culture": "The Tal Barahi Temple on the lake's island is an important Hindu shrine, reachable by boat.",
    "local_food": "Lakeside is full of cafes serving everything from momos to pizza and Israeli food, reflecting Pokhara's long-running backpacker trail history.",
    "emergency_info": null,
    "locals_know": "The classic mirror-still reflection of the Annapurna range is a dawn thing, not a sunset thing — by mid-morning, breeze picks up and ripples the surface, so early risers get the postcard shot and everyone else gets a nice but ordinary lake photo.",
    "tourist_mistakes": "Getting into a boat without agreeing on the price and duration first is the most common complaint visitors report here — settle both before you get in, not after.",
    "best_season": "October-April",
    "worst_season": "July-August (monsoon; poor visibility of the mountains)",
    "difficulty": "easy",
    "budget_level": "budget",
    "time_required": "2-3 hours, or a full day with boating",
    "latitude": 28.2096,
    "longitude": 83.9539,
    "altitude_m": 827,
    "district": {
      "name": "Kaski",
      "slug": "kaski"
    },
    "published": true
  },
  {
    "name": "Annapurna Base Camp",
    "slug": "annapurna-base-camp",
    "category": "viewpoint",
    "summary": "A 7-12 day trek into a natural amphitheater surrounded by the Annapurna massif.",
    "body": "Annapurna Base Camp (ABC), 4,130m, sits inside a bowl of 7,000m+ peaks. Shorter and generally less extreme in altitude than Everest Base Camp, making it a popular first major trek in Nepal.",
    "why_visit": "The 360-degree amphitheater of peaks at the base camp itself is one of the most dramatic mountain panoramas reachable without technical climbing.",
    "history": "Popularized after the first ascent of Annapurna I in 1950 (the first 8,000m peak ever climbed) and the opening of the region to trekkers in the following decades.",
    "culture": "The trail passes through Gurung and Magar villages, with distinct architecture and, in places, working rhododendron forests that bloom in spring.",
    "local_food": null,
    "emergency_info": "Lower peak altitude than EBC, but AMS is still a real risk above 3,000m — acclimatize accordingly.",
    "locals_know": "Most teahouses along this route are family-run by the Gurung and Magar households of the villages you pass through — asking about the village itself, not just ordering food, is genuinely appreciated and often leads to better, more current trail advice than a guidebook.",
    "tourist_mistakes": "Skipping acclimatization days to save time is the most common mistake on this trek specifically — ABC's altitude is lower than Everest Base Camp's, which lulls some trekkers into treating AMS risk too casually here.",
    "best_season": "March-May, September-November",
    "worst_season": "June-August (monsoon)",
    "difficulty": "hard",
    "budget_level": "mid_range",
    "time_required": "7-12 days round trip from Pokhara",
    "latitude": 28.5308,
    "longitude": 83.8794,
    "altitude_m": 4130,
    "district": {
      "name": "Kaski",
      "slug": "kaski"
    },
    "published": true
  },
  {
    "name": "Pashupatinath Temple",
    "slug": "pashupatinath-temple",
    "category": "temple",
    "summary": "One of the holiest Hindu temples in the world, on the banks of the Bagmati River.",
    "body": "Pashupatinath is a UNESCO World Heritage Site and Nepal's most important Hindu temple, dedicated to Shiva. Non-Hindus cannot enter the main temple but can view the complex, including the cremation ghats, from across the river.",
    "why_visit": "One of the most important Shiva temples in the world and a working cremation site — a direct, unfiltered look at Hindu ritual life and death.",
    "history": "The main temple structure dates to the 5th century, though the site has been a place of worship for far longer; it has been rebuilt several times after fires and earthquakes.",
    "culture": "Cremations happen daily on the ghats along the Bagmati; sadhus (Hindu holy men) are often present. Visitors should dress modestly and be respectful — this is a working religious and funerary site, not a tourist attraction first.",
    "local_food": null,
    "emergency_info": null,
    "locals_know": "Regular worshippers tend to visit early morning, before tour groups arrive — quieter, and it also means you're less likely to stumble into a cremation-viewing crowd without warning, which many first-time visitors find harder to process than expected.",
    "tourist_mistakes": "Photographing cremations up close is a serious cultural misstep, not just poor etiquette — photograph respectfully from the designated viewing areas across the river, never from among mourning families.",
    "best_season": "Year-round",
    "worst_season": "None significant, though monsoon afternoons bring heavy rain",
    "difficulty": "easy",
    "budget_level": "budget",
    "time_required": "1-2 hours",
    "latitude": 27.7104,
    "longitude": 85.3487,
    "altitude_m": 1341,
    "district": {
      "name": "Kathmandu",
      "slug": "kathmandu"
    },
    "published": true
  },
  {
    "name": "Boudhanath Stupa",
    "slug": "boudhanath-stupa",
    "category": "unesco_site",
    "summary": "One of the largest stupas in the world and the center of Tibetan Buddhist culture in Kathmandu.",
    "body": "Boudhanath's massive white dome and painted eyes are a Kathmandu landmark. The surrounding neighborhood has one of the largest populations of Tibetan exiles outside Tibet, with dozens of monasteries nearby.",
    "why_visit": "The best place in Kathmandu to see Tibetan Buddhist culture in daily practice — monks, pilgrims circumambulating (kora), butter-lamp offerings, and prayer flags.",
    "history": "Believed to date to the 14th century (possibly earlier legends place its founding centuries before that), rebuilt after the 2015 earthquake damaged its spire.",
    "culture": "Walk clockwise around the stupa, as pilgrims do. The surrounding rooftop cafes are popular for evening views as the lamps are lit.",
    "local_food": "The neighborhood has excellent Tibetan food — thukpa, momos, and Tibetan bread.",
    "emergency_info": null,
    "locals_know": "The evening lamp-lighting draws the biggest crowds and best atmosphere, but residents who do their kora daily often go at dawn instead — the rooftop cafes are empty, the light on the stupa is better for photos, and it's the version of Boudhanath locals actually experience day to day.",
    "tourist_mistakes": "Walking counter-clockwise around the stupa, against the pilgrim flow, is a common and easily avoided mistake — always circle clockwise, the same direction as everyone else.",
    "best_season": "Year-round",
    "worst_season": "None significant",
    "difficulty": "easy",
    "budget_level": "budget",
    "time_required": "1-2 hours",
    "latitude": 27.7215,
    "longitude": 85.362,
    "altitude_m": 1350,
    "district": {
      "name": "Kathmandu",
      "slug": "kathmandu"
    },
    "published": true
  },
  {
    "name": "Swayambhunath",
    "slug": "swayambhunath",
    "category": "unesco_site",
    "summary": "The \"Monkey Temple\" — an ancient hilltop stupa overlooking the Kathmandu Valley.",
    "body": "Swayambhunath is among the oldest religious sites in Nepal, over 1,500 years old. The 365-step climb to the hilltop stupa is rewarded with panoramic views over Kathmandu.",
    "why_visit": "The best panoramic viewpoint over the Kathmandu Valley combined with one of the valley's oldest and most sacred Buddhist sites.",
    "history": "Legend and some archaeological evidence date the site to before the 5th century, making it one of the oldest religious sites in the valley.",
    "culture": "Sacred to both Buddhists and Hindus. The resident macaque monkeys (hence the nickname) are considered holy in local legend.",
    "local_food": null,
    "emergency_info": "The 365-step climb has no shade and can be strenuous in heat; there is also a road-accessible side entrance for those who prefer not to climb.",
    "locals_know": "Most tour groups funnel through the main eastern staircase; the western, road-accessible side entrance reaches the same hilltop viewpoint with a fraction of the foot traffic — worth knowing if the crowds on the steps look overwhelming.",
    "tourist_mistakes": "Underestimating the 365-step climb in midday heat is a common mistake — visit early morning, or use the road-accessible side entrance if you're there outside the cooler months.",
    "best_season": "Year-round",
    "worst_season": "None significant",
    "difficulty": "moderate",
    "budget_level": "budget",
    "time_required": "1-2 hours",
    "latitude": 27.7149,
    "longitude": 85.2903,
    "altitude_m": 1400,
    "district": {
      "name": "Kathmandu",
      "slug": "kathmandu"
    },
    "published": true
  },
  {
    "name": "Kathmandu Durbar Square",
    "slug": "kathmandu-durbar-square",
    "category": "unesco_site",
    "summary": "The historic royal palace complex of the former Kathmandu Kingdom.",
    "body": "Kathmandu Durbar Square is a UNESCO World Heritage Site housing the old royal palace (Hanuman Dhoka), temples, and the residence of the Kumari, Nepal's living goddess.",
    "why_visit": "The most concentrated collection of Newar palace and temple architecture in the valley, and the historic seat of the Kathmandu Kingdom.",
    "history": "Developed over centuries under the Malla and later Shah dynasties; several structures were damaged in the 2015 earthquake and have since been restored.",
    "culture": "Home to the Kumari Ghar, residence of the Kumari — a young girl worshipped as a living goddess in Newar Hindu-Buddhist tradition.",
    "local_food": null,
    "emergency_info": null,
    "locals_know": "Nepali citizens are charged a different, much lower entry rate than foreign visitors at this and most of the valley's UNESCO sites — this is standard practice here, not a scam, but it can surprise travelers if a Nepali friend accompanying them pays a visibly different price at the gate.",
    "tourist_mistakes": "Not realizing there's sometimes a separate camera/photography fee beyond the entrance ticket catches visitors off guard — check current rules at the ticket counter before you start shooting.",
    "best_season": "Year-round",
    "worst_season": "None significant",
    "difficulty": "easy",
    "budget_level": "budget",
    "time_required": "2-3 hours",
    "latitude": 27.704,
    "longitude": 85.307,
    "altitude_m": 1300,
    "district": {
      "name": "Kathmandu",
      "slug": "kathmandu"
    },
    "published": true
  },
  {
    "name": "Patan Durbar Square",
    "slug": "patan-durbar-square",
    "category": "unesco_site",
    "summary": "Newar architecture and courtyards in the \"City of Fine Arts.\"",
    "body": "Patan Durbar Square is widely considered the best-preserved of the valley's three durbar squares, known for intricate wood and metal craftsmanship and its Krishna Mandir temple.",
    "why_visit": "Generally considered the best-preserved and least crowded of the valley's three durbar squares, with an excellent on-site museum.",
    "history": "Patan (Lalitpur) is one of the oldest cities in the Kathmandu Valley, with a Buddhist and Newar craft heritage dating back over a thousand years.",
    "culture": "Still a working center for traditional metalwork and thangka painting — many workshops around the square are open to visitors.",
    "local_food": null,
    "emergency_info": null,
    "locals_know": "The metalwork and thangka workshops here are genuinely working ateliers, not stage-set tourist shops — craftspeople are generally happy to have visitors watch work in progress if asked politely, more so than at the more heavily touristed craft stalls in central Kathmandu.",
    "tourist_mistakes": "Rushing through in under an hour on the way to somewhere else is the most common regret visitors report — the on-site museum alone rewards a slower visit than most day-tour itineraries allow for.",
    "best_season": "Year-round",
    "worst_season": "None significant",
    "difficulty": "easy",
    "budget_level": "budget",
    "time_required": "2-3 hours",
    "latitude": 27.6727,
    "longitude": 85.3247,
    "altitude_m": 1280,
    "district": {
      "name": "Lalitpur",
      "slug": "lalitpur"
    },
    "published": true
  },
  {
    "name": "Bhaktapur Durbar Square",
    "slug": "bhaktapur-durbar-square",
    "category": "unesco_site",
    "summary": "A living medieval city, largely car-free, with the best-preserved old-town atmosphere in the valley.",
    "body": "Bhaktapur retains more of its medieval character than Kathmandu or Patan, with pottery and weaving still practiced in its old squares. The 55-Window Palace and Nyatapola Temple are highlights.",
    "why_visit": "The most immersive \"step back in time\" experience of the three durbar squares — largely car-free streets, working potters' squares, and less redevelopment than Kathmandu or Patan.",
    "history": "Once the capital of an independent Malla kingdom (14th-18th centuries); its relative isolation historically helped preserve its old-town character.",
    "culture": "Famous for Juju Dhau (\"king curd\"), a local yogurt specialty, and for hosting some of the valley's most important festivals, including Bisket Jatra.",
    "local_food": "Try Juju Dhau (king curd) — a Bhaktapur specialty sold throughout the old town.",
    "emergency_info": null,
    "locals_know": "Juju Dhau sold right next to the entrance gates tends to carry a day-tripper markup — the same product from a stall further into the old town, away from the main gates, is usually cheaper and just as good.",
    "tourist_mistakes": "Treating this as a rushed half-day add-on to a Kathmandu/Patan day-trip is the most common way people shortchange it — Bhaktapur genuinely rewards a dedicated half-day of its own, not a squeezed-in hour at the end of a longer day.",
    "best_season": "Year-round",
    "worst_season": "None significant",
    "difficulty": "easy",
    "budget_level": "budget",
    "time_required": "Half day",
    "latitude": 27.671,
    "longitude": 85.4298,
    "altitude_m": 1401,
    "district": {
      "name": "Bhaktapur",
      "slug": "bhaktapur"
    },
    "published": true
  },
  {
    "name": "Chitwan National Park",
    "slug": "chitwan-national-park",
    "category": "national_park",
    "summary": "UNESCO World Heritage-listed lowland jungle, home to one-horned rhinos and Bengal tigers.",
    "body": "Chitwan National Park is Nepal's premier wildlife destination — jeep safaris, canoe trips, and jungle walks with a chance to see one-horned rhinoceros, and more rarely, Bengal tigers and gharial crocodiles.",
    "why_visit": "Nepal's best chance to see the greater one-horned rhinoceros in the wild, plus over 500 recorded bird species.",
    "history": "Established as Nepal's first national park in 1973 and inscribed as a UNESCO World Heritage Site in 1984, a major early success story in Asian rhino conservation.",
    "culture": "The surrounding buffer zone is home to Tharu communities, with distinct architecture, dance, and cuisine.",
    "local_food": "Tharu cuisine — dhikri (steamed rice-flour dumplings) and ghongi (snails) are local specialties around Sauraha.",
    "emergency_info": "Always visit with a licensed guide — this is wild territory with rhinos, sloth bears and (rarely) tigers.",
    "locals_know": "Guides generally say the best rhino and bird sightings come from early canoe trips, not jeep safaris — animals are more active and less disturbed before engine noise picks up later in the morning.",
    "tourist_mistakes": "Booking a jungle walk or safari without confirming it's with a licensed guide is a real safety mistake here, not just a formality — this is genuine wildlife territory with rhinos, sloth bears, and rarely, tigers.",
    "best_season": "October-March",
    "worst_season": "June-September (monsoon; park partially closed, flooding risk)",
    "difficulty": "easy",
    "budget_level": "mid_range",
    "time_required": "2-3 days",
    "latitude": 27.5291,
    "longitude": 84.3542,
    "altitude_m": 150,
    "district": {
      "name": "Chitwan",
      "slug": "chitwan"
    },
    "published": true
  },
  {
    "name": "Lumbini",
    "slug": "lumbini",
    "category": "unesco_site",
    "summary": "The birthplace of Siddhartha Gautama, the Buddha — a UNESCO World Heritage pilgrimage site.",
    "body": "Lumbini marks the exact birthplace of the Buddha, marked by the Maya Devi Temple and the Ashoka Pillar (3rd century BCE). Dozens of countries have built monasteries in the surrounding Monastic Zone.",
    "why_visit": "One of Buddhism's four most important pilgrimage sites, and a genuinely peaceful place to walk between dozens of national monasteries, each built in a different architectural style.",
    "history": "Confirmed as the Buddha's birthplace by the Ashoka Pillar inscription (3rd century BCE); rediscovered by archaeologists in 1896 after centuries as a largely forgotten site.",
    "culture": "The Monastic Zone hosts monasteries built by Buddhist communities from Thailand, Japan, Myanmar, Vietnam, Germany and more, each reflecting their home country's architectural style.",
    "local_food": null,
    "emergency_info": null,
    "locals_know": "The Monastic Zone is flat, walkable, and free to move through between monasteries — renting a bicycle at the entrance covers the whole zone comfortably in a few hours, which locals consider the better way to see it compared to a guided vehicle tour that stops at only a few sites.",
    "tourist_mistakes": "Trying to see the whole Monastic Zone on foot in Terai heat is a common mistake that leads to people cutting the visit short — rent a bicycle at the entrance instead of walking the whole thing.",
    "best_season": "October-March",
    "worst_season": "April-June (very hot in the Terai)",
    "difficulty": "easy",
    "budget_level": "budget",
    "time_required": "Full day",
    "latitude": 27.4833,
    "longitude": 83.2767,
    "altitude_m": 150,
    "district": {
      "name": "Rupandehi",
      "slug": "rupandehi"
    },
    "published": true
  },
  {
    "name": "Upper Mustang",
    "slug": "upper-mustang",
    "category": "other",
    "summary": "A restricted-area trans-Himalayan desert kingdom, culturally closer to Tibet than the rest of Nepal.",
    "body": "Upper Mustang requires a special restricted-area permit (separate from standard trekking permits) and preserves a Tibetan Buddhist culture largely unchanged for centuries. The walled city of Lo Manthang is the historic capital.",
    "why_visit": "A stark, high-altitude desert landscape and Tibetan Buddhist culture with almost none of the crowds of the classic trekking routes.",
    "history": "Was an independent kingdom until 2008, ruled by a line of kings tracing back to the 15th century; the walled capital Lo Manthang is largely intact.",
    "culture": "One of the best-preserved pockets of traditional Tibetan Buddhist culture anywhere, including areas of Tibet itself.",
    "local_food": null,
    "emergency_info": "Remote and roadless in parts — evacuation takes longer than in more visited regions. Requires a special restricted-area permit and a licensed guide by law.",
    "locals_know": "Because a licensed local guide is legally required here, that guide is also usually your best source for which villages happen to have a small local festival or market day during your specific trip window — these aren't published anywhere in advance and shift year to year with the lunar calendar.",
    "tourist_mistakes": "Underestimating how cold nights get despite the desert daytime heat is a common packing mistake — pack for genuinely cold nights even though days can be surprisingly warm and dry.",
    "best_season": "June-September (rain-shadow region — this is actually the best time, opposite of the rest of Nepal)",
    "worst_season": "December-February (severe cold, some routes may be inaccessible)",
    "difficulty": "hard",
    "budget_level": "luxury",
    "time_required": "10-14 days",
    "latitude": 29.1833,
    "longitude": 83.9667,
    "altitude_m": 3840,
    "district": {
      "name": "Mustang",
      "slug": "mustang"
    },
    "published": true
  },
  {
    "name": "Nagarkot",
    "slug": "nagarkot",
    "category": "viewpoint",
    "summary": "Hill station east of Kathmandu famous for Himalayan sunrise views over the valley.",
    "body": "Nagarkot (2,195m) is a 32km drive from Kathmandu, popular for sunrise views of Everest, Langtang, and the Annapurna range on clear days. Hotels line the ridge for overnight stays.",
    "why_visit": "The easiest Himalayan panorama from Kathmandu without trekking — see eight peaks on a clear morning.",
    "history": "Developed as a hill station and viewing point from the 1960s as Kathmandu tourism grew.",
    "culture": "Tamang and Brahmin villages surround the tourist ridge.",
    "local_food": "Hotel restaurants and small local eateries — dal bhat standard.",
    "emergency_info": "Nearest major hospital Kathmandu (1.5 hours). Tourist Police 1144.",
    "locals_know": "Sunrise is the event — set alarm for 5:30 AM, check weather forecast night before. Clouds ruin the view.",
    "tourist_mistakes": "Visiting midday expecting mountain views — haze and clouds obscure peaks after 9 AM most days.",
    "best_season": "October-April",
    "worst_season": "June-September (monsoon clouds)",
    "difficulty": "easy",
    "budget_level": "mid_range",
    "time_required": "Half day or overnight",
    "latitude": 27.7154,
    "longitude": 85.5203,
    "altitude_m": 2195,
    "district": {
      "name": "Bhaktapur",
      "slug": "bhaktapur"
    },
    "published": true
  }
];

export function getStaticDestinationBySlug(slug) {
	return DESTINATION_CATALOG.find((d) => d.slug === slug) || null;
}

export function getAllStaticDestinations() {
	return DESTINATION_CATALOG.slice();
}
